import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../components/shadcn/ui/dialog";
import { Button } from "../../../components/shadcn/ui/button";
import { getAuth } from "firebase/auth"; // Importe o Firebase Auth
import { getTokenFromStorage } from "@/utils/getToken";
import { toast } from "@/components/shadcn/ui/use-toast";

interface CollabSelectionModalProps {
  isOpen: boolean; // Controla se o modal está aberto
  onClose: () => void; // Função para fechar o modal
}

const CollabSelectionModal: React.FC<CollabSelectionModalProps> = ({ isOpen, onClose }) => {
  const [collaborators, setCollaborators] = useState<{ id: string; name: string }[]>([]); // Lista de colaboradores com id
  const [selectedCollaborator, setSelectedCollaborator] = useState<string>(""); // Colaborador selecionado
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const token = localStorage.getItem("APP_ACCESS_TOKEN");
  let Btoken = '';
  
  const API_URL = "/ws/api";

  useEffect(() => {
    if (isOpen) {
      fetchCollaborators();
    }
  }, [isOpen]);

  const fetchCollaborators = async () => {
    setLoading(true);
    setError("");
    try {
      
      const response = await fetch(`${API_URL}/Collab`,{
        headers: {
          'Authorization':`Bearer ${getTokenFromStorage()}`
        }
      });
      if (!response.ok) {
        throw new Error("Failed to fetch collaborators.");
      }
      const data = await response.json(); // Inspecione a resposta no console para confirmar

      if (data.collaborators && Array.isArray(data.collaborators)) {
        setCollaborators(data.collaborators);
      } else {
        throw new Error("Unexpected response format.");
      }
    } catch (err: any) {
      setError(err.message || "An error occurred while fetching collaborators.");
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = async () => {
    if (selectedCollaborator) {
      const collaborator = collaborators.find((collab) => collab.name === selectedCollaborator);
      if (token != null){
        const ParsedToken =JSON.parse(token);
        Btoken = ParsedToken.token
      }
      if (collaborator) {
        const auth = getAuth();
        const userEmail = auth.currentUser?.email;
        if (userEmail) {
          try {
            setLoading(true);
            const response = await fetch(`${API_URL}/update-colaborator`, {
              method: "POST",
              headers: {
                "Authorization": `Bearer ${Btoken}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                email: userEmail,
                colaboratorId: collaborator.id,
              }),
            });

            if (!response.ok) {
              throw new Error("Failed to update collaborator.");
            }

            const result = await response.json();
            return  toast({description:'Colaborador vinculado com sucesso, relogue para salvar mudança'})// Inspecione o resultado no console

            onClose(); // Fechar o modal após a atualização
          } catch (error: any) {
            setError(error.message || "An error occurred while updating the collaborator.");
          } finally {
            setLoading(false);
          }
        }
      }
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-md mx-auto p-6">
        <DialogHeader>
          <DialogTitle>Vincular Colaborador</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-4">
          {loading ? (
            <p>Carregando...</p>
          ) : error ? (
            <p className="text-red-500 text-sm">{error}</p>
          ) : (
            <select
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              value={selectedCollaborator}
              onChange={(e) => setSelectedCollaborator(e.target.value)}
            >
              <option value="" disabled>Vincular um colaborador</option>
              {collaborators.map((collab) => (
                <option key={collab.id} value={collab.name}>
                  {collab.name}
                </option>
              ))}
            </select>
          )}

          <Button
            onClick={handleSelect}
            disabled={loading || !selectedCollaborator}
            className="w-full"
          >
            Selecionar Colaborador
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CollabSelectionModal;
